//CompReport.tsx =================================================
import "../Util/Prototypes";

import * as Custom from "../Custom";
import * as Default from "../Default";
import * as SalesAverages from "./SalesAverages";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import { blueGrey, yellow } from '@mui/material/colors';

import React from "react";
import ReactDOM from "react-dom/client";

//Build the comp report.
export function render() {
   Util.logMsg("Building Comp Report");

   if (!Settings.printDivRoot) {
      Settings.setPrintDivRoot(ReactDOM.createRoot(document.getElementById("print_div")));
   }
   Settings.printDivRoot.render(<Render />);
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Component did update.
   React.useEffect(() => {
      Util_App.openPrintWindow("Sales Report", "Sales");
   });

   //Build data table.
   const ss: SalesSearchSettings.iSS = SalesSearchSettings.ss;
   const propTypeSpec: SalesSearchSettings.iPropType = SalesSearchSettings.getPropTypeSpec(SalesSearch.propertyType);
   const omitImproveSpec: SalesSearchSettings.iOmitImproveTypeCriteria = SalesSearchSettings.getOmitImproveTypeSpec(SalesSearch.improvementType);

   const lay: Search.iLayer = SalesSearch.layer;
   const fs = lay.fs;

   //Get selected indexes.
   const compIndexes: number[] = [];

   for (let i: number = 0; i < fs.features.length; i++) {
      const gra = fs.features[i] as any;
      if (gra.rowSelected) {
         compIndexes.Add(i);
      }
   }

   //Get table rows.
   function getTableRows() {
      const jsx: JSX.Element[] = [];
      const fields: Util_App.iField[] = Util_App.getFeatureValues(fs, fs.features[0], lay.name);

      //Process each field as a row.
      for (let i: number = 0; i < fs.fields.length; i++) {
         const field: Util_App.iField = fields[i];

         if (Settings.security.accessLevel >= field.accessLevel) {
            jsx.push(
               <tr key={Util.uid()}>
                  {getTableRowValues(i, field)}
               </tr>,
            );
         }
      }
      return jsx;
   }

   //Get table row values.
   function getTableRowValues(ii: number, field: Util_App.iField) {
      const jsx: JSX.Element[] = [];
      let m: number;

      const styles2: Default.iStyles = {
         aliasCell: { margin: 0, padding: '2px 6px 2px 6px', border: '1px solid silver', backgroundColor: blueGrey[50], textAlign: 'left' },
         subjectCell: { margin: 0, padding: '2px 6px 2px 6px', border: '1px solid silver', backgroundColor: yellow[50], textAlign: 'right' },
         compCell: { margin: 0, padding: '2px 6px 2px 6px', border: '1px solid silver', textAlign: 'right' },
      };

      //Process all columns (alias name, subject, and up to 3 sales points)
      for (let j: number = -2; j < compIndexes.length; j++) {

         //Alias name.
         if (j === -2) {
            jsx.push(<td key={Util.uid()} style={styles2.aliasCell}>{field.alias}</td>);

            //Subject parcel.
         } else if (j === -1) {
            let subjectVal: string = "";
            const fs_subject = Search.layers[0].fs;
            const subjectFields: Util_App.iField[] = Util_App.getFeatureValues(fs_subject, fs_subject.features[0], Settings.parcelLayerName);

            //Get subject value from subject field settings.
            if (ss.subjectField[field.name.toLowerCase()]) {
               const fieldName_subject = ss.subjectField[field.name.toLowerCase()];

               m = Util_App.getFieldIndexByName(fieldName_subject, fs_subject);
               if (m !== -1) {
                  const subjectField: Util_App.iField = subjectFields[m];
                  subjectVal = subjectField.value;

                  if (field.alias === "Sale Price") {
                     subjectVal = "Appraised: " + subjectVal;
                  }
               }

            } else { //Otherwise, get subject value from criteria settings.
               for (const key of propTypeSpec.criteriaKeys) {
                  if (omitImproveSpec && omitImproveSpec.criteriaKeys.Contains(key)) {
                     continue;
                  }

                  const criteria: SalesSearchSettings.iCriteria = ss[key];
                  if (criteria && (typeof criteria.weighting !== "undefined")) {
                     if (field.name === criteria.field) {
                        subjectVal = criteria.subjectValue.toString();
                        break;
                     }
                  }
               }
            }

            //Set price per sq ft or acre.
            if (field.name === "pricePerSqFt" || field.name === "pricePerAcre") {
               let marketValue: number = 0;

               m = Util_App.getFieldIndexByName(ss.SalePrice.subjectField, fs_subject);
               if (m !== -1) {
                  const subjectField: Util_App.iField = subjectFields[m];
                  marketValue = subjectField.value;
                  const txt: string = marketValue.toString().replace(/\$/g, "").replace(/,/g, "").trim();  //Remove formatting.
                  marketValue = Util.parseInteger(txt);
               }

               let sqFt: number = ss.LotSize.subjectValue;
               if (field.name === "pricePerSqFt") {
                  sqFt = ss.StructureSize.subjectValue;
               }

               if (sqFt > 0) {
                  subjectVal = (marketValue / sqFt).toString();
                  subjectVal = Util.formatTextValue(subjectVal, "Money");
               }
            }

            jsx.push(<td key={Util.uid()} style={styles2.subjectCell}>{subjectVal}</td>);

            //Sales point.
         } else {
            const k: number = compIndexes[j];
            const fields: Util_App.iField[] = Util_App.getFeatureValues(fs, fs.features[k], lay.name);
            const compField: Util_App.iField = fields[ii];
            jsx.push(<td key={Util.uid()} style={styles2.compCell}>{getTableRowValue(compField)}</td>);
         }

      } //end for all columns.
      return jsx;
   }

   //Get table row value.
   function getTableRowValue(field: Util_App.iField) {
      const jsx: JSX.Element[] = [];

      if (field.url === "") {
         jsx.push(
            <span key={Util.uid()}>{field.value}</span>,
         );

      } else {
         if (field.url && field.url.StartsWith("js:")) {
            jsx.push(
               <a key={Util.uid()} href="#" onClick={() => Custom.callFunction(field.url)}>{field.value}</a>,
            );

         } else {
            jsx.push(
               <a key={Util.uid()} href={field.url} target="_blank">{field.value}</a>,
            );
         }
      }
      return jsx;
   }

   //Styles.
   const styles: Default.iStyles = {
      row1Container: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
      col1Container: { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' },
      table: { borderCollapse: 'collapse', borderSpacing: 0, marginTop: 22 },
      headingCell: { margin: 0, padding: '2px 6px 2px 6px', border: '1px solid silver', backgroundColor: blueGrey[50], fontWeight: 'bold', textAlign: 'center' },
   };

   // style={{width: "400pt"}}
   return (
      <div>
         <div style={styles.row1Container}>
            <div style={styles.col1Container}>
               <div style={{ fontSize: "12pt" }}>{Settings.print.title}</div>
               <div style={{ margin: 3, marginBottom: 15 }}>Similar Properties Report</div>
            </div>
         </div>

         <div style={styles.row1Container}>
            <div style={{ width: 450 }}>
               <SalesAverages.Render />
            </div>
         </div>

         <div style={styles.row1Container}>
            <table style={styles.table}>
               <thead>
                  <tr>
                     <th></th>
                     <th style={styles.headingCell}>Subject</th>
                     {compIndexes.map((i: number, j: number) => (
                        <th key={Util.uid()} style={styles.headingCell}>
                           Sale #{j + 1}
                        </th>
                     ))}
                  </tr>
               </thead>

               <tbody>
                  {getTableRows()}
               </tbody >
            </table>
         </div>

      </div>
   ); //end return.

} //end function.
